import  { useState } from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  Card, 
  CardContent, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import { 
  Check as CheckIcon, 
  Close as CloseIcon, 
  RemoveRedEye as ViewIcon,
 
} from '@mui/icons-material';
import Layout from "../components/layout/CompliceLayout";

const CompliceDocumentApproval = () => {
    const [documents, setDocuments] = useState([
        {
          id: 1,
          name: 'Q4 Financial Report',
          submittedBy: 'John Doe',
          submissionDate: '2024-03-15',
          type: 'Financial',
          currentStage: 1,
          stages: [
            { name: 'Initial Review', status: 'In Progress', assignedTo: 'Finance Manager' },
            { name: 'Compliance Check', status: 'Pending', assignedTo: '' },
            { name: 'Final Approval', status: 'Pending', assignedTo: '' }
          ],
          comments: []
        },
        {
          id: 2,
          name: 'Cybersecurity Policy Update',
          submittedBy: 'Jane Smith',
          submissionDate: '2024-03-10',
          type: 'Compliance',
          currentStage: 0,
          stages: [
            { name: 'Initial Review', status: 'Pending', assignedTo: '' },
            { name: 'Technical Review', status: 'Pending', assignedTo: '' },
            { name: 'Final Approval', status: 'Pending', assignedTo: '' }
          ],
          comments: []
        }
      ]);
    
      const [openReviewDialog, setOpenReviewDialog] = useState(false);
      const [selectedDocument, setSelectedDocument] = useState(null);
      const [reviewComment, setReviewComment] = useState('');
      const [assignee, setAssignee] = useState('');
    
      const possibleAssignees = [
        'Finance Manager',
        'Compliance Officer',
        'Legal Team',
        'IT Security',
        'Executive Team'
      ];
    
      const handleOpenReview = (document) => {
        setSelectedDocument(document);
        setOpenReviewDialog(true);
      };
    
      const handleApproveDocument = (approve = true) => {
        if (!selectedDocument) return;
    
        const updatedDocuments = documents.map(doc => {
          if (doc.id === selectedDocument.id) {
            const updatedStages = [...doc.stages];
            const currentStage = doc.currentStage;
    
            // Update current stage status
            updatedStages[currentStage] = {
              ...updatedStages[currentStage],
              status: approve ? 'Approved' : 'Rejected',
              assignedTo: assignee
            };
    
            // Move to next stage if approved
            const nextStageIndex = currentStage + 1;
            if (approve && nextStageIndex < updatedStages.length) {
              updatedStages[nextStageIndex] = {
                ...updatedStages[nextStageIndex],
                status: 'In Progress'
              };
            }
    
            return {
              ...doc,
              currentStage: approve ? nextStageIndex : currentStage,
              stages: updatedStages,
              comments: [
                ...doc.comments,
                {
                  text: reviewComment,
                  status: approve ? 'Approved' : 'Rejected',
                  timestamp: new Date().toISOString()
                }
              ]
            };
          }
          return doc;
        });
    
        setDocuments(updatedDocuments);
        setOpenReviewDialog(false);
        setReviewComment('');
        setAssignee('');
      };
  return (
    <Layout>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Document Approval Workflow
        </Typography>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Document Name</TableCell>
                <TableCell>Submitted By</TableCell>
                <TableCell>Submission Date</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Current Stage</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {documents.map((doc) => (
                <TableRow key={doc.id}>
                  <TableCell>{doc.name}</TableCell>
                  <TableCell>{doc.submittedBy}</TableCell>
                  <TableCell>{doc.submissionDate}</TableCell>
                  <TableCell>{doc.type}</TableCell>
                  <TableCell>
                    <Stepper activeStep={doc.currentStage} alternativeLabel>
                      {doc.stages.map((stage, index) => (
                        <Step key={stage.name}>
                          <StepLabel
                            error={stage.status === "Rejected"}
                            completed={stage.status === "Approved"}
                          >
                            {stage.name}
                          </StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      color="primary"
                      startIcon={<ViewIcon />}
                      onClick={() => handleOpenReview(doc)}
                    >
                      Review
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Document Review Dialog */}
        <Dialog
          open={openReviewDialog}
          onClose={() => setOpenReviewDialog(false)}
          maxWidth="md"
          fullWidth
        >
          {selectedDocument && (
            <>
              <DialogTitle>
                Document Review: {selectedDocument.name}
              </DialogTitle>
              <DialogContent>
                <Grid container spacing={2}>
                  {/* Document Details */}
                  <Grid item xs={12} md={6}>
                    <Card variant="outlined">
                      <CardContent>
                        <Typography variant="h6">Document Details</Typography>
                        <Typography>
                          Submitted By: {selectedDocument.submittedBy}
                        </Typography>
                        <Typography>
                          Submission Date: {selectedDocument.submissionDate}
                        </Typography>
                        <Typography>Type: {selectedDocument.type}</Typography>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Current Stage Details */}
                  <Grid item xs={12} md={6}>
                    <Card variant="outlined">
                      <CardContent>
                        <Typography variant="h6">Current Stage</Typography>
                        <Typography>
                          Stage:{" "}
                          {
                            selectedDocument.stages[
                              selectedDocument.currentStage
                            ].name
                          }
                        </Typography>
                        <FormControl fullWidth sx={{ mt: 2 }}>
                          <InputLabel>Assign to</InputLabel>
                          <Select
                            value={assignee}
                            label="Assign to"
                            onChange={(e) => setAssignee(e.target.value)}
                          >
                            {possibleAssignees.map((assigneeName) => (
                              <MenuItem key={assigneeName} value={assigneeName}>
                                {assigneeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Review Comments */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={4}
                      label="Review Comments"
                      variant="outlined"
                      value={reviewComment}
                      onChange={(e) => setReviewComment(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => handleApproveDocument(false)}
                  color="error"
                  startIcon={<CloseIcon />}
                  disabled={!assignee}
                >
                  Reject
                </Button>
                <Button
                  onClick={() => handleApproveDocument(true)}
                  color="primary"
                  variant="contained"
                  startIcon={<CheckIcon />}
                  disabled={!assignee}
                >
                  Approve
                </Button>
              </DialogActions>
            </>
          )}
        </Dialog>
      </Box>
    </Layout>
  );
};

export default CompliceDocumentApproval;
